import ImageTextBlock from "@/components/ui/image-text-block";
import { useTranslations } from "use-intl";
import S from "./index.module.scss";

const Founding = () => {
  const t = useTranslations("about");

  return (
    <ImageTextBlock image={"/images/about/header.png"}>
      <div className={S.content}>
        <h1 className={S.title}>{t("header")}</h1>
      </div>
    </ImageTextBlock>
  )
};

export default Founding;